import React, { Component } from "react";
import { View, Text } from "react-native";

import * as x from "../../styles/css";

class Header extends Component {
	render() {
		return (
			<View style={[x.mb.three, {...this.props.containerStyle} ]}>
				<Text
					style={[x.fonts.header, {
						color: this.props.color || x.colors.default,
						...this.props.style,
					}]}
				>
					{this.props.children}
				</Text>
			</View>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js